export default "__VITE_ASSET__DYK9als1__"